import { createContext } from 'react';
const UpcomingContext = createContext(undefined);
export default UpcomingContext;
//# sourceMappingURL=context.js.map